import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  NATracksReqObj,
  NATracksRespObj,
} from '@/api/models';

export async function getLocationTracks(
  req: NATracksReqObj,
): Promise<NATracksRespObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/LocationTracks',
    req,
  );
  return unwrapContainer<NATracksRespObj>(response.data);
}
